import * as yup from "yup";

const logValidationError = (message) => {
  console.log(`Validation failed: ${message}`);
  return false; // Returning `false` means the validation failed
};

const commonSchemaAcrossAllVaraints = {
  // sampleReceivedDate: yup
  //   .string()
  //   .required("Please provide Sample Received Date")
  //   .matches(/^(?!\s+$).+/, "Special characters are not allowed in Sample Received Date")
  //   .label("Sample Received Date")
  //   .test("log-error", "Please provide Sample Received Date", function (value) {
  //     if (!value || /^\s*$/.test(value)) {
  //       logValidationError("Sample Received Date is invalid or missing");
  //       return false;
  //     }
  //     return true;
  //   }),
  // samplePhysicalCondition: yup
  //   .string()
  //   .required("Please provide values for Sample Physical Condition")
  //   .matches(
  //     /^[a-zA-Z0-9\s]+$/,
  //     "Special characters are not allowed in Sample Physical Condition"
  //   )
  //   .label("Physical Condition")
  //   .test(
  //     "log-error",
  //     "Please provide Sample Physical Condition",
  //     function (value) {
  //       if (!value || /^\s*$/.test(value)) {
  //         logValidationError("Sample Physical Condition is invalid or missing");
  //         return false;
  //       }
  //       return true;
  //     }
  //   ),
  // sampleSealNumber: yup
  //   .string()
  //   .required("Please provide values for Sample Seal Number")
  //   .matches(
  //     /^[a-zA-Z0-9\s-]+$/,
  //     "Special characters are not allowed in Sample Seal Number"
  //   )
  //   .label("Sample Seal Number")
  //   .test("log-error", "Please provide Sample Seal Number", function (value) {
  //     if (!value || /^\s*$/.test(value)) {
  //       logValidationError("Sample Seal Number is invalid or missing");
  //       return false;
  //     }
  //     return true;
  //   }),
  // conditionOfSeal: yup
  //   .string()
  //   .required("Please provide values for Condition Of Seal")
  //   .matches(/^(?!\s+$).+/, "Please provide values for Condition Of Seal")
  //   .label("Condition of Seal")
  //   .test("log-error", "Please provide Condition of Seal", function (value) {
  //     if (!value || /^\s*$/.test(value)) {
  //       logValidationError("Condition of Seal is invalid or missing");
  //       return false;
  //     }
  //     return true;
  //   }),
  // additionalSampleNeeded: yup
  //   .string()
  //   .required("Please select one for Additional Sample Required")
  //   .matches(/^(?!\s+$).+/, "Please select one for Additional Sample Required")
  //   .label("Additional Sample Needed"),
  // additionalSampleReasons: yup.string().when("additionalSampleNeeded", {
  //   is: (value) => {
  //     return value === "Yes";
  //   },
  //   then: yup
  //     .string()
  //     .required("Please provide reason for Additional Sample")
  //     .matches(/^(?!\s+$).+/, "Please provide reason for Additional Sample")
  //     .label("Reason For Additional Sample")
  //     .test(
  //       "log-error",
  //       "Please provide reason for Additional Sample",
  //       function (value) {
  //         if (!value || /^\s*$/.test(value)) {
  //           logValidationError(
  //             "Additional Sample Reasons is invalid or missing"
  //           );
  //           return false;
  //         }
  //         return true;
  //       }
  //     ),
  //   otherwise: yup.string(),
  // }),
  // sampleRegistrationNumber: yup
  //   .string()
  //   .required("Please provide Sample Registration Number")
  //   .matches(
  //     /^[a-zA-Z0-9\s]+$/,
  //     "Special characters are not allowed in Sample Registration Number"
  //   )
  //   .label("Sample Registration Number")
  //   .test(
  //     "log-error",
  //     "Please provide Sample Registration Number",
  //     function (value) {
  //       if (!value || /^\s*$/.test(value)) {
  //         logValidationError(
  //           "Sample Registration Number is invalid or missing"
  //         );
  //         return false;
  //       }
  //       return true;
  //     }
  //   ),
  // expectedDateOfCompletion: yup
  //   .string()
  //   .required("Please provide Expected Completion Date")
  //   .matches(/^(?!\s+$).+/, "Please provide Expected Completion Date")
  //   .label("Expected Completion Date")
  //   .test("log-error", "Please provide Expected Completion Date", function (value) {
  //     if (!value || /^\s*$/.test(value)) {
  //       logValidationError("Expected Date of Completion is invalid or missing");
  //       return false;
  //     }
  //     return true;
  //   }),
  frontImage: yup
    .array()
    .min(1, "Please upload at least 1 image")
    .required("Front Image is required!")
    // .test("is-image", "The file must be of image type", (files) => {
    //   return (
    //     Array.isArray(files) &&
    //     files.length > 0 &&
    //     files.every((file) =>
    //       file?.originFileObj?.type?.startsWith("image/")
    //     )
    //   );
    // }),
    ,
    backImage: yup
    .array()
    .min(1, "Please upload at least 1 image")
    .required("Back Image is required!")
    // .test("is-image", "The file must be of image type", (files) => {
    //   return (
    //     Array.isArray(files) &&
    //     files.length > 0 &&
    //     files.every((file) =>
    //       file?.originFileObj?.type?.startsWith("image/")
    //     )
    //   );
    // }),
    
};
const schemaOjectForNormalVaraint = {
  ...commonSchemaAcrossAllVaraints,
  fssaiLogoPresent: yup
    .string()
    .typeError("Please select option for the above field")
    .required("Please select option for the above field")
    .matches(
      /^(?!\s+$).+/,
      "Please select option for Fssai Logo Present or Not"
    )
    .label("Is FSSAI Logo available on the pack?")
    .test("log-error", "Please provide Fssai Logo Present", function (value) {
      if (!value || /^\s*$/.test(value)) {
        logValidationError("fssai logo is invalid or missing");
        return false;
      }
      return true;
    }),
  brandNamePresent: yup
    .string()
    .required("Please select option for the above field")
    .matches(/^(?!\s+$).+/, "Please select option for the above field")
    .label("Is Brand Name Present?")
    .test("log-error", "Please provide Brand Name Present", function (value) {
      if (!value || /^\s*$/.test(value)) {
        logValidationError("Brand Name Present is invalid or missing");
        return false;
      }
      return true;
    }),
  brandName: yup.string().when("brandNamePresent", {
    is: (value) => {
      return value === "Yes";
    },
    then: yup
    .string()
    .typeError("Please provide Brand Name")
    .required("Please provide Brand Name")
    .matches(
      /^[a-zA-Z0-9\s]+$/,
      "Special characters are not allowed in Brand Name"
    )
    .label("Brand Name")
    .test("log-error", "Please provide Brand Name", function (value) {
      if (!value || /^\s*$/.test(value)) {
        logValidationError("brand name is invalid or missing");
        return false;
      }
      return true;
    }),
    otherwise: yup.string(),
  }),
    manufacturingDatePresent: yup
    .string()
    .typeError("Please select option for the above field")
    .required("Please select option for the above field")
    .matches(/^(?!\s+$).+/, "Please select option for the above field")
    .label("Is Manufacturing Date Present on the Pack?")
    .test("log-error", "Please provide Manufacturing Date Present", function (value) {
      if (!value || /^\s*$/.test(value)) {
        logValidationError("Manufacturing Date Present is invalid or missing");
        return false;
      }
      return true;
    }),
  manufacturingDate: yup.string().when("manufacturingDatePresent", {
    is: (value) => {
      return value === "Yes";
    },
    then: yup
    .string()
    .typeError("Please provide Manufacturing Date")
    .required("Please provide Manufacturing Date")
    .matches(/^(?!\s+$).+/, "Please provide Manufacturing Date")
    .label("Lot/Code/Batch No.")
    .test("log-error", "Please provide Manufacturing Date", function (value) {
      if (!value || /^\s*$/.test(value)) {
        logValidationError("manufacturing date is invalid or missing");
        return false;
      }
      return true;
    }),
    otherwise: yup.string(),
  }),
   lotNumberPresent: yup
    .string()
    .typeError("Please select option for the above field")
    .required("Please select option for the above field")
    .matches(/^(?!\s+$).+/, "Please select option for the above field")
    .label("Is Lot Number Present on the Pack?")
    .test("log-error", "Please provide Lot Number", function (value) {
      if (!value || /^\s*$/.test(value)) {
        logValidationError("lot number is invalid or missing");
        return false;
      }
      return true;
    }),
  lotNumber: yup.string().when("lotNumberPresent",{
    is:(value)=>{
        return value === "Yes";
    },
    then: yup
    .string()
    .typeError("Please provide Lot Number")
    .required("Please provide Lot Number")
    .matches(
      /^[a-zA-Z0-9\s&*()\-_{}[\]|\\:;/,.~_]+$/,
      "Please provide valid Lot Number"
    )
    .label("Lot Number")
    .test("log-error", "Please provide Lot Number", function (value) {
      if (!value || /^\s*$/.test(value)) {
        logValidationError("lot number is invalid or missing");
        return false;
      }
      return true;
    }),
    otherwise: yup.string()
     }),
  vegSymbolPresent: yup
    .string()
    .typeError("Select Option")
    .required("Please select option for the above field")
    .matches(/^(?!\s+$).+/, "Please select option for the above field")
    .label("Sample Registration Number")
    .test("log-error", "Please provide Veg Symbol Present", function (value) {
      if (!value || /^\s*$/.test(value)) {
        logValidationError("veg symbol present is invalid or missing");
        return false;
      }
      return true;
    }),
  vegOrNonVeg: yup.string().when("vegSymbolPresent", {
    is: (value) => {
      return value === "Yes";
    },
    then: yup
      .string()
      .typeError("Please provide Veg Or Non Veg")
      .required("Please provide Veg Or Non Veg")
      .matches(/^(?!\s+$).+/, "Please provide Veg Or Non Veg")
      .label("Country Of Origin")
      .test("log-error", "Please provide Veg Or Non Veg", function (value) {
        if (!value || /^\s*$/.test(value)) {
          logValidationError("Veg Or Non Veg is invalid or missing");
          return false;
        }
        return true;
      }),
    otherwise: yup.string(),
  }),
  expireByDatePresent: yup
    .string()
    .typeError("Please select option for the above field")
    .required("Please select option for the above field")
    .matches(/^(?!\s+$).+/, "Please select option for the above field")
    .label("Is Expiry Date Present on the Pack?")
    .test("log-error", "Please provide Expiry Date Present", function (value) {
      if (!value || /^\s*$/.test(value)) {
        logValidationError("veg symbol present is invalid or missing");
        return false;
      }
      return true;
    }),
  expireByDate: yup.string().when("expireByDatePresent",{
    is: (value) => {
      return value === "Yes";
    },
    then: yup
    .string()
    .typeError("Please provide Expire By Date")
    .required("Please provide Expire By Date")
    .matches(/^(?!\s+$).+/, "Please provide Expire By Date")
    .label("Expire By Date")
    .test(
      "is-greater",
      "Expiry Date must be after Manufacturing Date",
      function (value) {
        const { manufacturingDate } = this.parent;
        if (!value || !manufacturingDate) return true;
        return new Date(value) > new Date(manufacturingDate);
      }
    ),
    otherwise: yup.string()
     }),
  manufacturingAddressPresent: yup
    .string()
    .typeError("Please select option for the above field")
    .required("Please select option for the above field")
    .matches(/^(?!\s+$).+/, "Please select option for the above field")
    .label("Does the sample have Manufacturing Address?")
    .test("log-error", "Please provide Manufacturing Date Present", function (value) {
      if (!value || /^\s*$/.test(value)) {
        logValidationError("veg symbol present is invalid or missing");
        return false;
      }
      return true;
    }),
    manufacturingAddress: yup
    .string()
    .label("Manufacturing Address")
    .when("manufacturingAddressPresent", {
      is: (val) => val === "Yes", // required only when present is Yes
      then: (schema) =>
        schema
          .required("Please provide Manufacturing Address"),
      otherwise: (schema) => schema.notRequired(),
    }),
    fssaiLicenseNumberPresent: yup
    .string()
    .typeError("Please select option for the above field")
    .required("Please select option for the above field")
    .matches(/^(?!\s+$).+/, "Please select option for the above field")
    .label("FSSAI License Number Present")
    .test(
      "log-error",
      "Please provide FSSAI License Number Present",
      function (value) {
        if (!value || /^\s*$/.test(value)) {
          logValidationError(
            "FSSAI License Number Present is invalid or missing"
          );
          return false;
        }
        return true;
      }
    ),
  fssaiLicenseNumber: yup.string().when("fssaiLicenseNumberPresent", {
    is: (value) => {
      return value === "Yes";
    },
    then: yup
      .string()
      .typeError("Please provide Fssai License Number ")
      .required("Please provide Fssai License Number")
      .min(14)
      .max(14)
      .matches(/^[0-9]+$/, "Please provide numeric values for the above field")
      .label("Provide FSSAI License Number")
      .test(
        "log-error",
        "Please provide FSSAI License Number",
        function (value) {
          if (!value || /^\s*$/.test(value)) {
            logValidationError("Fssai License Number is invalid or missing");
            return false;
          }
          return true;
        }
      ),
    otherwise: yup.string(),
  }),
  countryOfOriginPresent: yup
    .string()
    .typeError("Please select option for the above field")
    .required("Please select option for the above field")
    .matches(/^(?!\s+$).+/, "Please select option for the above field")
    .label("Sample Registration Number")
    .test("log-error", "Please provide Country Of Origin Present", function (value) {
      if (!value || /^\s*$/.test(value)) {
        logValidationError("Country Of Origin Present is invalid or missing");
        return false;
      }
      return true;
    }),
  countryOfOrigin: yup.string().when("countryOfOriginPresent", {
    is: (value) => {
      return value === "Yes";
    },
    then: yup
      .string()
      .typeError("Please provide Country of Origin")
      .required("Please provide Country of Origin")
      .matches(/^(?!\s+$).+/, "Please provide Country of Origin")
      .label("Country Of Origin")
      .test("log-error", "Please provide Country of Origin", function (value) {
        if (!value || /^\s*$/.test(value)) {
          logValidationError("Country of Origin is invalid or missing");
          return false;
        }
        return true;
      }),
    otherwise: yup.string(),
  }),
};

const provideLabSampleReceptionSchema = (variant) => {
  const looseVariantSchema = yup.object().shape({
    ...commonSchemaAcrossAllVaraints,
    //manufacturingAddress: yup.string(),
  });

  const normalVariantSchema = yup.object().shape({
    ...schemaOjectForNormalVaraint,
  });

  const organicVariantSchema = yup.object().shape({
    ...schemaOjectForNormalVaraint,

    jaivikKisanLogoPresent: yup
      .string()
      .typeError("Please select option for Jaivik Kisan Logo Present")
      .required("Please select option for Jaivik Kisan Logo Present")
      .matches(/^(?!\s+$).+/, "Please select option for the above field")
      .label("Jaivik Kisan Logo")
      .test(
        "log-error",
        "Please provide value for Jaivik Kisan Logo",
        function (value) {
          if (!value || /^\s*$/.test(value)) {
            logValidationError("Jaivik Kisan Logo is invalid or missing");
            return false;
          }
          return true;
        }
      ),
  });

  if (variant === "Loose") {
    return looseVariantSchema;
  } else if (variant === "Organic") {
    return organicVariantSchema;
  } else if (variant === "Normal") {
    return normalVariantSchema;
  }
};

export default provideLabSampleReceptionSchema;
